import {post} from '../utils'

const url = (host, channelId) => `${host}/public/channel/${channelId}/help`

export default host => (channelId, name, email, query) =>
  post(url(host, channelId), JSON.stringify({name: name, email: email, query: query}))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)